import type { SheetPreview } from '@shared/forge-sheet-preview';
import { Button } from '@/components/ui';
import { ViewRouter } from '@/components/views/ViewRouter';

/**
 * The tool's result screen drawn from the usage sheet (decision Forge FDE,
 * F3): the real Domino view with fictional example data. The sandbox test
 * shows real data; this only shows what the tool will look like.
 */
export const SheetPreviewPanel = ({ preview, loading, error, onRetry }: {
  preview: SheetPreview | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}) => (
  <section aria-label="Aperçu de l’outil" className="space-y-3">
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <h2 className="text-sm font-semibold text-domino-ink">Aperçu de l’outil</h2>
      <p className="text-xs text-domino-inkSoft">
        {loading && preview ? 'Mise à jour d’après la fiche…' : 'Exemple fictif, d’après la fiche'}
      </p>
    </div>
    {preview ? <div className={loading ? 'opacity-60 transition-opacity' : undefined}><ViewRouter payload={preview.envelope} /></div>
      : loading ? <p className="text-sm text-domino-inkSoft">Domino dessine l’aperçu…</p>
        : null}
    {error && <p role="alert" className="text-sm text-domino-inkSoft">
      {error} <Button variant="ghost" size="sm" onClick={onRetry}>Réessayer</Button>
    </p>}
  </section>
);
